import { render, staticRenderFns } from "./PerfilUsuarioAssociacaoPage.vue?vue&type=template&id=7ff6b68c&scoped=true"
import script from "./PerfilUsuarioAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./PerfilUsuarioAssociacaoPage.vue?vue&type=script&lang=js"
import style0 from "./PerfilUsuarioAssociacaoPage.vue?vue&type=style&index=0&id=7ff6b68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff6b68c",
  null
  
)

export default component.exports